export type RawFile = {
  label: string;
  key: string;
  originName?: unknown;
  storedName?: unknown;
};

export function normalizeName(n: unknown): string | null {
  if (n === undefined || n === null) return null;
  try {
    if (typeof n === 'string') {
      const t = n.trim();
      if (!t || t === 'null' || t === 'undefined') return null;

      // JSON array
      if (t.startsWith('[') && t.endsWith(']')) {
        try {
          const parsed = JSON.parse(t);
          if (Array.isArray(parsed) && parsed.length > 0) return String(parsed[0]);
        } catch (e) {
          console.debug('normalizeName JSON parse error', e);
        }
      }

      // comma separated
      if (t.includes(',')) {
        const parts = t
          .split(',')
          .map((s: string) => s.trim())
          .filter(Boolean);
        if (parts.length > 0) return parts[0];
      }

      return t;
    }

    if (Array.isArray(n) && n.length > 0) return String(n[0]);
    return String(n);
  } catch (e) {
    console.debug('normalizeName error', e);
    return null;
  }
}

export function getRawFilesFromItem(item: unknown): RawFile[] {
  const it = (item as Record<string, unknown>) || {};
  return [
    {
      label: '첨부파일',
      key: 'attachment',
      originName: it['FileOriginName'] ?? it['fileOriginName'],
      storedName: it['fileName'] ?? it['FileName']
    },
    {
      label: '사업자등록증 사본',
      key: 'businessRegistration',
      originName:
        it['businessFileOriginName'] ?? it['businessFileOrigin'] ?? it['businessFileName'],
      storedName: it['businessFileName']
    },
    {
      label: '재직증명서',
      key: 'employmentCertificate',
      originName:
        it['employmentFileOriginName'] ?? it['employmentFileOrigin'] ?? it['employmentFileName'],
      storedName: it['employmentFileName']
    },
    {
      label: '통신사이용증명원',
      key: 'telecomUsage',
      originName: it['telecomFileOriginName'] ?? it['telecomFileOrigin'] ?? it['telecomFileName'],
      storedName: it['telecomFileName']
    },
    {
      label: '발신번호벽작방지 및 사전동의서',
      key: 'consentForm',
      originName: it['consentFileOriginName'] ?? it['consentFileOrigin'] ?? it['consentFileName'],
      storedName: it['consentFileName']
    },
    {
      label: '특수부가사업자등록증',
      key: 'specialBusiness',
      originName:
        it['specialBusinessFileOriginName'] ??
        it['specialBusinessFileOrigin'] ??
        it['specialBusinessFileName'],
      storedName: it['specialBusinessFileName']
    },
    {
      label: '전송자격인증서',
      key: 'transmission',
      originName:
        it['transmissionFileOriginName'] ??
        it['transmissionFileOrigin'] ??
        it['transmissionFileName'],
      storedName: it['transmissionFileName']
    }
  ];
}

// map file key used in UI to backend 'type' query parameter
export function fileKeyToDownloadType(key?: string): string | undefined {
  if (!key) return undefined;
  const map: Record<string, string> = {
    attachment: 'attachment',
    businessRegistration: 'business',
    employmentCertificate: 'employment',
    telecomUsage: 'telecom',
    consentForm: 'consent',
    specialBusiness: 'specialBusiness',
    transmission: 'transmission'
  };
  return map[key] || key;
}
